(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const emblaNodes = document.querySelectorAll("[data-announcement-bar]");

    emblaNodes.forEach((emblaNode) => {
      const autoplaySpeed =
        parseInt(emblaNode.dataset.autoplaySpeed, 10) || 4000;
      const slidesCount = parseInt(emblaNode.dataset.slidesCount, 10) || 0;

      const isMobile = window.innerWidth < 1024;

      if (slidesCount <= 1 && isMobile) return;

      const autoplayOptions = {
        delay: autoplaySpeed,
        stopOnInteraction: false,
        stopOnMouseEnter: true,
      };

      const options = {
        loop: true,
        align: "center",
        skipSnaps: false,
        active: isMobile,
      };

      const autoplay = window.EmblaCarouselAutoplay(autoplayOptions);
      const embla = window.EmblaCarousel(emblaNode, options, [autoplay]);

      const handleResize = function () {
        const newIsMobile = window.innerWidth < 1024;
        if (newIsMobile !== embla.internalEngine().options.active) {
          embla.reInit({ ...options, active: newIsMobile });
        }
      };

      let resizeTimeout;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 100);
      });
    });
  });
})();
